export const SIGN_IN_DESTINATIONS = {
  SESSION: 'session',
  MFA_ENROLLMENT_CHOOSER: 'mfaEnrollmentChooser',
};

const formatDateStr = date =>
  [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');

export function DateStrFormat(addYear = 0) {
  const today = new Date();
  today.setFullYear(today.getFullYear() + addYear);
  return formatDateStr(today);
}

function isWithinDontAskAgainGrace() {
  const date_expiration = new Date(localStorage.getItem('date_expiration'));
  const today = new Date(DateStrFormat());
  return date_expiration.getTime() - today.getTime() > 0;
}

export const isInternalAccount = user => user.email.endsWith('@zippedi.com');

export function decideSignInDestination(user) {
  const mfaList = user.reloadUserInfo.mfaInfo;
  if (mfaList) {
    return SIGN_IN_DESTINATIONS.SESSION;
  }
  if (isInternalAccount(user)) {
    return SIGN_IN_DESTINATIONS.MFA_ENROLLMENT_CHOOSER;
  }
  return isWithinDontAskAgainGrace()
    ? SIGN_IN_DESTINATIONS.SESSION
    : SIGN_IN_DESTINATIONS.MFA_ENROLLMENT_CHOOSER;
}

export const DONT_ASK_AGAIN_MONTHS = 6;

const lastDayOfMonth = (year, month) => new Date(year, month + 1, 0).getDate();

export function rememberDontAskAgain() {
  const today = new Date();
  const expiration = new Date(
    today.getFullYear(),
    today.getMonth() + DONT_ASK_AGAIN_MONTHS,
    1,
  );
  expiration.setDate(
    Math.min(
      today.getDate(),
      lastDayOfMonth(expiration.getFullYear(), expiration.getMonth()),
    ),
  );
  localStorage.setItem('date_expiration', formatDateStr(expiration));
}
